module.exports = __webpack_public_path__ + "static/media/Power_Bi_logo.9fecb904.png";